import { Button, Form, InputOnChangeData, Modal } from "semantic-ui-react";
import { CalibrationCertificate } from "../models/CalibrationCertificate";
import { trancateTime } from "../utils";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import { useEffect, useState } from "react";

export interface FormData {
  catSerialNumber: string;
  catCalibrationDate: Date;
  catCalibrationDueDate: Date;
  gennySerialNumber: string;
  gennyCalibrationDate: Date;
  gennyCalibrationDueDate: Date;
}

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (calibrationCertificate: CalibrationCertificate) => void;
  calibrationCertificate?: CalibrationCertificate | null;
}

const CalibrationCertificateModal = ({ open, onClose, onSubmit, calibrationCertificate }: Props) => {
  const [formData, setFormData] = useState<FormData>({} as FormData);

  useEffect(() => {
    if (calibrationCertificate) {
      setFormData({
        catSerialNumber: calibrationCertificate.catSerialNumber,
        catCalibrationDate: calibrationCertificate.catCalibrationDate
          ? new Date(calibrationCertificate.catCalibrationDate)
          : undefined,
        catCalibrationDueDate: calibrationCertificate.catCalibrationDueDate
          ? new Date(calibrationCertificate.catCalibrationDueDate)
          : undefined,
        gennySerialNumber: calibrationCertificate.gennySerialNumber,
        gennyCalibrationDate: calibrationCertificate.gennyCalibrationDate
          ? new Date(calibrationCertificate.gennyCalibrationDate)
          : undefined,
        gennyCalibrationDueDate: calibrationCertificate.gennyCalibrationDueDate
          ? new Date(calibrationCertificate.gennyCalibrationDueDate)
          : undefined,
      } as FormData);
    } else {
      setFormData({} as FormData);
    }
  }, [open, calibrationCertificate]);

  const handleSubmit = () => {
    onSubmit({
      catSerialNumber: formData.catSerialNumber,
      catCalibrationDate: formData.catCalibrationDate ? trancateTime(formData.catCalibrationDate) : null,
      catCalibrationDueDate: formData.catCalibrationDueDate ? trancateTime(formData.catCalibrationDueDate) : null,
      gennySerialNumber: formData.gennySerialNumber,
      gennyCalibrationDate: formData.gennyCalibrationDate ? trancateTime(formData.gennyCalibrationDate) : null,
      gennyCalibrationDueDate: formData.gennyCalibrationDueDate ? trancateTime(formData.gennyCalibrationDueDate) : null,
    } as CalibrationCertificate);
    handelClose();
  };

  const handelClose = () => {
    onClose();
  };

  const handleChange = (e: any, { name, value }: InputOnChangeData) => {
    setFormData({ ...formData, [name]: value });
  };

  const onCatCalibrationDateChange = (e: any, data: any) => {
    setFormData({ ...formData, catCalibrationDate: data.value });
  };

  const onGennyCalibrationDateChange = (e: any, data: any) => {
    setFormData({ ...formData, gennyCalibrationDate: data.value });
  };

  const onCatCalibrationDueDateChange = (e: any, data: any) => {
    setFormData({ ...formData, catCalibrationDueDate: data.value });
  };

  const onGennyCalibrationDueDateChange = (e: any, data: any) => {
    setFormData({ ...formData, gennyCalibrationDueDate: data.value });
  };

  return (
    <>
      <Modal open={open} onClose={handelClose}>
        <Modal.Header>CAT and Genny</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Form>
              <Form.Group widths="equal">
                <Form.Input
                  label="CAT serial number"
                  name="catSerialNumber"
                  value={formData.catSerialNumber}
                  onChange={handleChange}
                  required
                />
                <SemanticDatepicker
                  label="CAT calibration date"
                  value={formData.catCalibrationDate}
                  locale="en-US"
                  onChange={onCatCalibrationDateChange}
                  type="basic"
                />
                <SemanticDatepicker
                  label="CAT calibration due date"
                  value={formData.catCalibrationDueDate}
                  locale="en-US"
                  onChange={onCatCalibrationDueDateChange}
                  type="basic"
                  required
                />
              </Form.Group>

              <Form.Group widths="equal">
                <Form.Input
                  label="Genny serial number"
                  name="gennySerialNumber"
                  value={formData.gennySerialNumber}
                  onChange={handleChange}
                  required
                />
                <SemanticDatepicker
                  label="Genny calibration date"
                  value={formData.gennyCalibrationDate}
                  locale="en-US"
                  onChange={onGennyCalibrationDateChange}
                  type="basic"
                />
                <SemanticDatepicker
                  label="Genny calibration due date"
                  value={formData.gennyCalibrationDueDate}
                  locale="en-US"
                  onChange={onGennyCalibrationDueDateChange}
                  type="basic"
                  required
                />
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={handelClose}>Cancel</Button>
          <Button onClick={handleSubmit} positive>
            Ok
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default CalibrationCertificateModal;
